import { REACH_RADIUS } from './constants.js';
export const FURNITURE_CATALOG = [
    /* structure */
    { kind: 'wall', label: 'Wall', category: 'structure', w: 1, h: 1, solid: true, color: '#1e293b', icon: '', occludes: 0.85 },
    { kind: 'glass_wall', label: 'Glass wall', category: 'structure', w: 1, h: 1, solid: true, color: '#38bdf855', icon: '', occludes: 0.7 },
    { kind: 'door', label: 'Door', category: 'structure', w: 2, h: 1, solid: false, color: '#7c2d12', icon: '🚪', floor: true, occludes: 0.75 },
    { kind: 'window', label: 'Window', category: 'structure', w: 3, h: 1, solid: true, color: '#7dd3fc', icon: '🪟', occludes: 0.7 },
    { kind: 'stairs', label: 'Stairs', category: 'structure', w: 3, h: 3, solid: false, color: '#475569', icon: '🪜', floor: true, pattern: 'stripes' },
    { kind: 'elevator', label: 'Elevator', category: 'structure', w: 3, h: 3, solid: true, color: '#64748b', icon: '🛗', occludes: 0.85 },
    { kind: 'rug', label: 'Rug', category: 'structure', w: 6, h: 4, solid: false, color: '#7c3aed', icon: '', floor: true, pattern: 'stripes' },
    { kind: 'rug_round', label: 'Round rug', category: 'structure', w: 5, h: 5, solid: false, color: '#be185d', icon: '', floor: true, pattern: 'dots' },
    { kind: 'tiles', label: 'Tiled floor', category: 'structure', w: 8, h: 6, solid: false, color: '#334155', icon: '', floor: true, pattern: 'checker' },
    { kind: 'wood_floor', label: 'Wood floor', category: 'structure', w: 8, h: 6, solid: false, color: '#78350f', icon: '', floor: true, pattern: 'wood' },
    { kind: 'floor_mark', label: 'Floor marking', category: 'structure', w: 4, h: 4, solid: false, color: '#22c55e', icon: '', floor: true, pattern: 'stripes' },
    { kind: 'partition', label: 'Partition', category: 'structure', w: 4, h: 1, solid: true, color: '#3f3f46', icon: '', occludes: 0.45 },
    { kind: 'pillar', label: 'Pillar', category: 'structure', w: 1, h: 1, solid: true, color: '#52525b', icon: '', occludes: 0.35 },
    /* desks */
    { kind: 'desk', label: 'Desk', category: 'desks', w: 4, h: 2, solid: true, color: '#334155', icon: '🖥' },
    { kind: 'standing_desk', label: 'Standing desk', category: 'desks', w: 4, h: 2, solid: true, color: '#3f4c63', icon: '🧍' },
    { kind: 'double_desk', label: 'Double desk', category: 'desks', w: 6, h: 3, solid: true, color: '#2f3b52', icon: '🖥' },
    { kind: 'monitor', label: 'Monitor', category: 'desks', w: 2, h: 1, solid: true, color: '#0f172a', icon: '🖵' },
    { kind: 'printer', label: 'Printer', category: 'desks', w: 2, h: 2, solid: true, color: '#64748b', icon: '🖨' },
    { kind: 'cabinet', label: 'Cabinet', category: 'desks', w: 2, h: 1, solid: true, color: '#57534e', icon: '🗄' },
    { kind: 'bookshelf', label: 'Bookshelf', category: 'desks', w: 3, h: 1, solid: true, color: '#78350f', icon: '📚' },
    { kind: 'lockers', label: 'Lockers', category: 'desks', w: 3, h: 1, solid: true, color: '#475569', icon: '🔐' },
    { kind: 'drafting_table', label: 'Drafting table', category: 'desks', w: 3, h: 2, solid: true, color: '#92400e', icon: '📐' },
    /* seating */
    { kind: 'chair', label: 'Chair', category: 'seating', w: 1, h: 1, solid: false, color: '#475569', icon: '🪑' },
    { kind: 'couch', label: 'Couch', category: 'seating', w: 5, h: 2, solid: true, color: '#166534', icon: '🛋' },
    { kind: 'armchair', label: 'Armchair', category: 'seating', w: 2, h: 2, solid: true, color: '#15803d', icon: '🛋' },
    { kind: 'beanbag', label: 'Beanbag', category: 'seating', w: 2, h: 2, solid: true, color: '#b45309', icon: '🟠' },
    { kind: 'bar_stool', label: 'Bar stool', category: 'seating', w: 1, h: 1, solid: true, color: '#92400e', icon: '🪑' },
    { kind: 'bench', label: 'Bench', category: 'seating', w: 4, h: 1, solid: true, color: '#6b7280', icon: '🪑' },
    { kind: 'coffee_table', label: 'Coffee table', category: 'seating', w: 3, h: 2, solid: true, color: '#78350f', icon: '' },
    { kind: 'hammock', label: 'Hammock', category: 'seating', w: 3, h: 2, solid: true, color: '#0d9488', icon: '🪢' },
    /* meeting */
    { kind: 'table', label: 'Meeting table', category: 'meeting', w: 6, h: 4, solid: true, color: '#7c2d12', icon: '🪑' },
    { kind: 'round_table', label: 'Round table', category: 'meeting', w: 4, h: 4, solid: true, color: '#854d0e', icon: '⭕' },
    { kind: 'whiteboard', label: 'Whiteboard', category: 'meeting', w: 4, h: 1, solid: true, color: '#e2e8f0', icon: '📋' },
    { kind: 'flipchart', label: 'Flip chart', category: 'meeting', w: 2, h: 1, solid: true, color: '#f8fafc', icon: '📈' },
    { kind: 'podium', label: 'Podium', category: 'meeting', w: 2, h: 2, solid: true, color: '#78350f', icon: '🎙' },
    { kind: 'stage', label: 'Stage decking', category: 'meeting', w: 10, h: 3, solid: false, color: '#b45309', icon: '', floor: true, pattern: 'wood' },
    { kind: 'screen', label: 'Presentation screen', category: 'meeting', w: 4, h: 1, solid: true, color: '#0ea5e9', icon: '📺', glow: 'rgba(14,165,233,0.22)' },
    { kind: 'booth', label: 'Booth', category: 'meeting', w: 4, h: 3, solid: true, color: '#0891b2', icon: '🏪' },
    { kind: 'phone_booth', label: 'Phone booth', category: 'meeting', w: 2, h: 2, solid: true, color: '#7e22ce', icon: '☎', occludes: 0.8 },
    /* kitchen */
    { kind: 'coffee', label: 'Coffee machine', category: 'kitchen', w: 2, h: 2, solid: true, color: '#78350f', icon: '☕' },
    { kind: 'fridge', label: 'Fridge', category: 'kitchen', w: 2, h: 2, solid: true, color: '#cbd5e1', icon: '🧊' },
    { kind: 'microwave', label: 'Microwave', category: 'kitchen', w: 2, h: 1, solid: true, color: '#94a3b8', icon: '🍲' },
    { kind: 'water_cooler', label: 'Water cooler', category: 'kitchen', w: 1, h: 1, solid: true, color: '#38bdf8', icon: '🚰' },
    { kind: 'snack_bar', label: 'Snack bar', category: 'kitchen', w: 6, h: 2, solid: true, color: '#a16207', icon: '🍪' },
    { kind: 'bar', label: 'Bar', category: 'kitchen', w: 8, h: 2, solid: true, color: '#854d0e', icon: '🍹' },
    { kind: 'kitchen_island', label: 'Kitchen island', category: 'kitchen', w: 4, h: 2, solid: true, color: '#57534e', icon: '🍽' },
    { kind: 'vending_machine', label: 'Vending machine', category: 'kitchen', w: 2, h: 1, solid: true, color: '#dc2626', icon: '🥤', glow: 'rgba(220,38,38,0.18)' },
    { kind: 'sink', label: 'Sink', category: 'kitchen', w: 2, h: 1, solid: true, color: '#94a3b8', icon: '🫧' },
    { kind: 'pizza_oven', label: 'Pizza oven', category: 'kitchen', w: 2, h: 2, solid: true, color: '#9a3412', icon: '🍕', glow: 'rgba(249,115,22,0.25)' },
    /* decor */
    { kind: 'plant', label: 'Plant', category: 'decor', w: 1, h: 1, solid: true, color: '#16a34a', icon: '🪴' },
    { kind: 'tree', label: 'Tree', category: 'decor', w: 2, h: 2, solid: true, color: '#15803d', icon: '🌳' },
    { kind: 'fountain', label: 'Fountain', category: 'decor', w: 3, h: 3, solid: true, color: '#38bdf8', icon: '⛲' },
    { kind: 'lamp', label: 'Lamp', category: 'decor', w: 1, h: 1, solid: false, color: '#fbbf24', icon: '💡', glow: 'rgba(251,191,36,0.30)' },
    { kind: 'floor_lamp', label: 'Floor lamp', category: 'decor', w: 1, h: 1, solid: true, color: '#fcd34d', icon: '🕯', glow: 'rgba(252,211,77,0.28)' },
    { kind: 'neon_sign', label: 'Neon sign', category: 'decor', w: 3, h: 1, solid: true, color: '#f472b6', icon: '💗', glow: 'rgba(244,114,182,0.28)' },
    { kind: 'aquarium', label: 'Aquarium', category: 'decor', w: 3, h: 1, solid: true, color: '#0ea5e9', icon: '🐠', glow: 'rgba(14,165,233,0.22)' },
    { kind: 'statue', label: 'Statue', category: 'decor', w: 1, h: 1, solid: true, color: '#a8a29e', icon: '🗿' },
    { kind: 'globe', label: 'Globe', category: 'decor', w: 1, h: 1, solid: true, color: '#0284c7', icon: '🌍' },
    { kind: 'mirror', label: 'Mirror', category: 'decor', w: 2, h: 1, solid: true, color: '#cbd5e1', icon: '🪞' },
    { kind: 'flowers', label: 'Flowers', category: 'decor', w: 1, h: 1, solid: false, color: '#fb7185', icon: '💐' },
    { kind: 'poster', label: 'Poster', category: 'decor', w: 2, h: 1, solid: true, color: '#be185d', icon: '🖼' },
    { kind: 'banner', label: 'Banner', category: 'decor', w: 6, h: 1, solid: false, color: '#6366f1', icon: '🚩' },
    { kind: 'clock', label: 'Clock', category: 'decor', w: 1, h: 1, solid: true, color: '#e2e8f0', icon: '🕐' },
    { kind: 'fire_pit', label: 'Fire pit', category: 'decor', w: 3, h: 3, solid: true, color: '#c2410c', icon: '🔥', glow: 'rgba(249,115,22,0.35)' },
    { kind: 'chandelier', label: 'Chandelier', category: 'decor', w: 2, h: 2, solid: false, color: '#fcd34d', icon: '✨', glow: 'rgba(253,224,71,0.30)' },
    { kind: 'zen_garden', label: 'Zen garden', category: 'decor', w: 4, h: 3, solid: false, color: '#a8a29e', icon: '', floor: true, pattern: 'water' },
    { kind: 'terrarium', label: 'Terrarium', category: 'decor', w: 2, h: 1, solid: true, color: '#22c55e', icon: '🦎', glow: 'rgba(34,197,94,0.18)' },
    { kind: 'waterfall_wall', label: 'Waterfall wall', category: 'decor', w: 3, h: 1, solid: true, color: '#0284c7', icon: '', pattern: 'water', glow: 'rgba(2,132,199,0.22)' },
    /* tech */
    { kind: 'server_rack', label: 'Server rack', category: 'tech', w: 2, h: 3, solid: true, color: '#1f2937', icon: '🖧' },
    { kind: 'tv', label: 'Wall TV', category: 'tech', w: 4, h: 1, solid: true, color: '#0f172a', icon: '📺' },
    { kind: 'camera', label: 'Camera', category: 'tech', w: 1, h: 1, solid: true, color: '#334155', icon: '🎥' },
    { kind: 'speaker', label: 'Speaker', category: 'tech', w: 1, h: 1, solid: true, color: '#374151', icon: '🔊' },
    { kind: 'charging_dock', label: 'Charging dock', category: 'tech', w: 2, h: 1, solid: true, color: '#16a34a', icon: '🔌', glow: 'rgba(22,163,74,0.2)' },
    { kind: 'hologram', label: 'Hologram display', category: 'tech', w: 2, h: 2, solid: true, color: '#06b6d4', icon: '🔮', glow: 'rgba(6,182,212,0.28)' },
    { kind: 'robot', label: 'Office robot', category: 'tech', w: 1, h: 1, solid: true, color: '#64748b', icon: '🤖' },
    /* fun */
    { kind: 'pool_table', label: 'Pool table', category: 'fun', w: 6, h: 3, solid: true, color: '#065f46', icon: '🎱' },
    { kind: 'ping_pong', label: 'Ping pong', category: 'fun', w: 6, h: 3, solid: true, color: '#1d4ed8', icon: '🏓' },
    { kind: 'foosball', label: 'Foosball', category: 'fun', w: 4, h: 3, solid: true, color: '#166534', icon: '⚽' },
    { kind: 'arcade', label: 'Arcade machine', category: 'fun', w: 2, h: 2, solid: true, color: '#7c3aed', icon: '🕹' },
    { kind: 'piano', label: 'Piano', category: 'fun', w: 4, h: 2, solid: true, color: '#111827', icon: '🎹' },
    { kind: 'darts', label: 'Darts', category: 'fun', w: 1, h: 1, solid: true, color: '#dc2626', icon: '🎯' },
    { kind: 'gong', label: 'Gong', category: 'fun', w: 2, h: 2, solid: true, color: '#ca8a04', icon: '🥁' },
    { kind: 'cake', label: 'Celebration cake', category: 'fun', w: 1, h: 1, solid: false, color: '#f472b6', icon: '🎂' },
    { kind: 'basketball', label: 'Basketball hoop', category: 'fun', w: 2, h: 1, solid: true, color: '#ea580c', icon: '🏀' },
    { kind: 'chess', label: 'Chess table', category: 'fun', w: 2, h: 2, solid: true, color: '#44403c', icon: '♟', pattern: 'checker' },
    { kind: 'jukebox', label: 'Jukebox', category: 'fun', w: 2, h: 1, solid: true, color: '#9333ea', icon: '🎶', glow: 'rgba(147,51,234,0.25)' },
    { kind: 'photo_booth', label: 'Photo booth', category: 'fun', w: 3, h: 3, solid: true, color: '#db2777', icon: '📸' },
    { kind: 'claw_machine', label: 'Claw machine', category: 'fun', w: 2, h: 2, solid: true, color: '#ec4899', icon: '🧸', glow: 'rgba(236,72,153,0.22)' },
    { kind: 'lego_table', label: 'Lego table', category: 'fun', w: 3, h: 2, solid: true, color: '#f59e0b', icon: '🧱' },
    { kind: 'karaoke', label: 'Karaoke machine', category: 'fun', w: 2, h: 1, solid: true, color: '#d946ef', icon: '🎤', glow: 'rgba(217,70,239,0.25)' },
    /* outdoor */
    { kind: 'grass', label: 'Grass', category: 'outdoor', w: 10, h: 8, solid: false, color: '#16a34a', icon: '', floor: true, pattern: 'grass' },
    { kind: 'path', label: 'Path', category: 'outdoor', w: 10, h: 2, solid: false, color: '#a8a29e', icon: '', floor: true, pattern: 'checker' },
    { kind: 'pond', label: 'Pond', category: 'outdoor', w: 6, h: 5, solid: true, color: '#0ea5e9', icon: '', floor: true, pattern: 'water' },
    { kind: 'hedge', label: 'Hedge', category: 'outdoor', w: 6, h: 1, solid: true, color: '#15803d', icon: '' },
    { kind: 'flower_bed', label: 'Flower bed', category: 'outdoor', w: 4, h: 2, solid: true, color: '#db2777', icon: '🌷' },
    { kind: 'picnic_table', label: 'Picnic table', category: 'outdoor', w: 4, h: 3, solid: true, color: '#a16207', icon: '🧺' },
    { kind: 'umbrella', label: 'Parasol', category: 'outdoor', w: 3, h: 3, solid: false, color: '#f59e0b', icon: '⛱' },
    { kind: 'bbq', label: 'Barbecue', category: 'outdoor', w: 2, h: 2, solid: true, color: '#7f1d1d', icon: '🍖', glow: 'rgba(239,68,68,0.22)' },
    { kind: 'bike_rack', label: 'Bike rack', category: 'outdoor', w: 3, h: 1, solid: true, color: '#64748b', icon: '🚲' },
    { kind: 'street_lamp', label: 'Street lamp', category: 'outdoor', w: 1, h: 1, solid: true, color: '#fde68a', icon: '🏮', glow: 'rgba(253,230,138,0.26)' },
    { kind: 'fence', label: 'Fence', category: 'outdoor', w: 4, h: 1, solid: true, color: '#78716c', icon: '' },
    { kind: 'greenhouse', label: 'Greenhouse', category: 'outdoor', w: 4, h: 3, solid: true, color: '#14b8a6', icon: '🌿' },
    { kind: 'swing_bench', label: 'Swing bench', category: 'outdoor', w: 3, h: 1, solid: true, color: '#a16207', icon: '' },
    /* wellness */
    { kind: 'nap_pod', label: 'Nap pod', category: 'wellness', w: 3, h: 2, solid: true, color: '#4c1d95', icon: '😴' },
    { kind: 'yoga_mat', label: 'Yoga mat', category: 'wellness', w: 3, h: 2, solid: false, color: '#7c3aed', icon: '🧘', floor: true },
    { kind: 'treadmill', label: 'Treadmill', category: 'wellness', w: 2, h: 3, solid: true, color: '#374151', icon: '🏃' },
    { kind: 'weights', label: 'Weights', category: 'wellness', w: 2, h: 1, solid: true, color: '#1f2937', icon: '🏋' },
    { kind: 'first_aid', label: 'First aid', category: 'wellness', w: 1, h: 1, solid: true, color: '#dc2626', icon: '🩹' },
    { kind: 'meditation', label: 'Meditation cushion', category: 'wellness', w: 1, h: 1, solid: false, color: '#a78bfa', icon: '🪷' },
    { kind: 'massage_chair', label: 'Massage chair', category: 'wellness', w: 2, h: 2, solid: true, color: '#7c3aed', icon: '💆' },
    { kind: 'punching_bag', label: 'Punching bag', category: 'wellness', w: 1, h: 1, solid: true, color: '#b91c1c', icon: '🥊' },
    { kind: 'sauna', label: 'Sauna', category: 'wellness', w: 3, h: 3, solid: true, color: '#b45309', icon: '🧖', glow: 'rgba(251,146,60,0.2)' },
    /* studio */
    { kind: 'ring_light', label: 'Ring light', category: 'studio', w: 1, h: 1, solid: true, color: '#fef3c7', icon: '💫', glow: 'rgba(254,243,199,0.32)' },
    { kind: 'green_screen', label: 'Green screen', category: 'studio', w: 5, h: 1, solid: true, color: '#22c55e', icon: '🟩' },
    { kind: 'camera_rig', label: 'Camera rig', category: 'studio', w: 2, h: 2, solid: true, color: '#18181b', icon: '🎬' },
    { kind: 'mic_boom', label: 'Mic boom', category: 'studio', w: 1, h: 1, solid: true, color: '#3f3f46', icon: '🎤' },
    { kind: 'mixing_desk', label: 'Mixing desk', category: 'studio', w: 4, h: 2, solid: true, color: '#292524', icon: '🎛' },
    { kind: 'easel', label: 'Easel', category: 'studio', w: 2, h: 2, solid: true, color: '#b45309', icon: '🎨' },
    { kind: 'vr_station', label: 'VR station', category: 'studio', w: 3, h: 3, solid: false, color: '#6d28d9', icon: '🥽', floor: true },
    { kind: 'printer_3d', label: '3D printer', category: 'studio', w: 2, h: 2, solid: true, color: '#0f766e', icon: '🖨' },
    /* signage */
    { kind: 'exit_sign', label: 'Exit sign', category: 'signage', w: 1, h: 1, solid: false, color: '#16a34a', icon: '🚪', glow: 'rgba(22,163,74,0.22)' },
    { kind: 'wayfinding', label: 'Wayfinding sign', category: 'signage', w: 2, h: 1, solid: false, color: '#475569', icon: '🧭' },
    { kind: 'arrow', label: 'Floor arrow', category: 'signage', w: 2, h: 2, solid: false, color: '#38bdf8', icon: '⬆', floor: true },
    { kind: 'notice_board', label: 'Notice board', category: 'signage', w: 3, h: 1, solid: true, color: '#92400e', icon: '📌' },
    { kind: 'welcome_mat', label: 'Welcome mat', category: 'signage', w: 3, h: 2, solid: false, color: '#7c2d12', icon: '', floor: true, pattern: 'stripes' },
    { kind: 'reception', label: 'Reception desk', category: 'signage', w: 5, h: 2, solid: true, color: '#1e40af', icon: '🛎' },
    /* seasonal */
    { kind: 'holiday_tree', label: 'Holiday tree', category: 'seasonal', w: 2, h: 2, solid: true, color: '#166534', icon: '🎄', glow: 'rgba(34,197,94,0.22)' },
    { kind: 'balloons', label: 'Balloons', category: 'seasonal', w: 1, h: 1, solid: false, color: '#f43f5e', icon: '🎈' },
    { kind: 'confetti', label: 'Confetti', category: 'seasonal', w: 4, h: 4, solid: false, color: '#facc15', icon: '', floor: true, pattern: 'dots' },
    { kind: 'pumpkin', label: 'Pumpkin', category: 'seasonal', w: 1, h: 1, solid: true, color: '#ea580c', icon: '🎃', glow: 'rgba(234,88,12,0.22)' },
    { kind: 'fireworks', label: 'Fireworks', category: 'seasonal', w: 2, h: 2, solid: false, color: '#a855f7', icon: '🎆', glow: 'rgba(168,85,247,0.25)' },
    { kind: 'gift_pile', label: 'Gifts', category: 'seasonal', w: 2, h: 2, solid: true, color: '#be123c', icon: '🎁' },
];
export const FURNITURE_BY_KIND = Object.fromEntries(FURNITURE_CATALOG.map((spec) => [spec.kind, spec]));
export const FURNITURE_CATEGORY_LABELS = {
    structure: 'Structure',
    desks: 'Desks & storage',
    seating: 'Seating',
    meeting: 'Meeting',
    kitchen: 'Kitchen & bar',
    decor: 'Decor',
    tech: 'Tech',
    fun: 'Fun',
    outdoor: 'Outdoor',
    wellness: 'Wellness',
    studio: 'Studio',
    signage: 'Signage',
    seasonal: 'Seasonal',
};
export const FURNITURE_CATEGORIES = [
    'structure',
    'desks',
    'seating',
    'meeting',
    'kitchen',
    'decor',
    'tech',
    'fun',
    'outdoor',
    'wellness',
    'studio',
    'signage',
    'seasonal',
];
/** Icon for a kind, falling back gracefully for anything unknown. */
export function furnitureIcon(kind) {
    return FURNITURE_BY_KIND[kind]?.icon ?? '';
}
export function isFloorDecor(kind) {
    return FURNITURE_BY_KIND[kind]?.floor ?? false;
}
/** Glow colour for props that light the floor around them. */
export function furnitureGlow(kind) {
    return FURNITURE_BY_KIND[kind]?.glow;
}
export function furniturePattern(kind) {
    return FURNITURE_BY_KIND[kind]?.pattern;
}
/* ----------------------------- the third axis ----------------------------- */
/**
 * How tall each kind of prop stands, in pixels of screen extrusion at world
 * scale (the same scale `TILE_SIZE` lives in, so web canvas and mobile SVG
 * agree on every height).
 *
 * The scale is architectural, not literal: a wall reaches highest, casework
 * and appliances stand waist-to-shoulder height, work surfaces lower, seats
 * lower still. Kinds missing from the table get a modest default; floor
 * decor is always flat.
 */
const ELEVATIONS = {
    /* structure */
    wall: 24,
    glass_wall: 24,
    window: 24,
    partition: 18,
    pillar: 22,
    elevator: 26,
    /* desks & storage */
    desk: 16,
    standing_desk: 20,
    double_desk: 16,
    drafting_table: 18,
    monitor: 11,
    printer: 14,
    cabinet: 14,
    bookshelf: 24,
    lockers: 24,
    /* seating */
    chair: 14,
    couch: 12,
    armchair: 12,
    beanbag: 7,
    bar_stool: 13,
    bench: 9,
    coffee_table: 10,
    hammock: 4,
    /* meeting */
    table: 17,
    round_table: 17,
    whiteboard: 22,
    flipchart: 22,
    podium: 18,
    screen: 14,
    booth: 20,
    phone_booth: 28,
    /* kitchen & bar */
    coffee: 8,
    fridge: 15,
    microwave: 6,
    water_cooler: 10,
    snack_bar: 10,
    bar: 11,
    kitchen_island: 10,
    vending_machine: 15,
    sink: 8,
    pizza_oven: 12,
    /* decor */
    plant: 6,
    tree: 10,
    fountain: 6,
    lamp: 8,
    floor_lamp: 12,
    neon_sign: 10,
    aquarium: 9,
    statue: 10,
    globe: 7,
    mirror: 10,
    flowers: 4,
    poster: 8,
    banner: 6,
    clock: 6,
    fire_pit: 5,
    chandelier: 10,
    terrarium: 7,
    waterfall_wall: 14,
    /* tech */
    server_rack: 15,
    tv: 8,
    camera: 6,
    speaker: 8,
    charging_dock: 4,
    hologram: 8,
    robot: 7,
    /* fun */
    pool_table: 9,
    ping_pong: 8,
    foosball: 9,
    arcade: 15,
    piano: 10,
    darts: 8,
    gong: 10,
    cake: 4,
    basketball: 10,
    chess: 7,
    jukebox: 12,
    photo_booth: 15,
    claw_machine: 15,
    lego_table: 7,
    karaoke: 8,
    /* outdoor */
    hedge: 9,
    flower_bed: 5,
    picnic_table: 8,
    bbq: 8,
    bike_rack: 5,
    street_lamp: 12,
    fence: 8,
    greenhouse: 13,
    swing_bench: 6,
    pond: 0,
    /* wellness */
    nap_pod: 9,
    yoga_mat: 0,
    treadmill: 7,
    weights: 4,
    first_aid: 6,
    meditation: 2,
    massage_chair: 9,
    punching_bag: 10,
    sauna: 14,
    /* studio */
    ring_light: 9,
    green_screen: 12,
    camera_rig: 9,
    mic_boom: 9,
    mixing_desk: 8,
    easel: 10,
    printer_3d: 8,
    vr_station: 0,
    /* signage */
    exit_sign: 8,
    wayfinding: 8,
    notice_board: 10,
    reception: 11,
    /* seasonal */
    holiday_tree: 12,
    balloons: 6,
    pumpkin: 4,
    fireworks: 4,
    gift_pile: 5,
};
/** Extrusion height for a kind. Floor decor is flat; unknown props modest. */
export function elevationOf(kind) {
    const listed = ELEVATIONS[kind];
    if (listed !== undefined)
        return listed;
    return FURNITURE_BY_KIND[kind]?.floor ? 0 : 8;
}
/**
 * Visible artwork may extend beyond the navigation footprint.
 *
 * A real task chair is wider than the single grid square its caster stem
 * occupies. Keeping that grid footprint avoids breaking existing desk rows,
 * while this padding lets renderers and hit tests agree on the full chair.
 */
export function furnitureVisualOverflow(kind) {
    if (kind === 'chair')
        return 10;
    if (kind === 'bar_stool')
        return 4;
    return 0;
}
/** Horizontal component of the shared top-left axonometric lift. */
export function axonometricLiftX(elevation) {
    return elevation * -0.28;
}
const swings = (over = {}) => ({
    kind: 'door',
    turnOn: 'Open',
    turnOff: 'Close',
    onLabel: 'Open',
    offLabel: 'Closed',
    // Doors rest open so an existing floor plan stays walkable until someone
    // decides otherwise — closing one is the deliberate act, not opening it.
    defaultOn: true,
    ...over,
});
const opens = (over = {}) => ({
    kind: 'lid',
    turnOn: 'Open',
    turnOff: 'Close',
    onLabel: 'Open',
    offLabel: 'Shut',
    defaultOn: false,
    ...over,
});
const powers = (over = {}) => ({
    kind: 'switch',
    turnOn: 'Turn on',
    turnOff: 'Turn off',
    onLabel: 'On',
    offLabel: 'Off',
    defaultOn: true,
    ...over,
});
const seats = (over = {}) => ({
    kind: 'seat',
    turnOn: 'Sit down',
    turnOff: 'Stand up',
    onLabel: 'Taken',
    offLabel: 'Free',
    defaultOn: false,
    ...over,
});
const runs = (verb, runsFor, busy = 'Busy') => ({
    kind: 'momentary',
    turnOn: verb,
    turnOff: verb,
    onLabel: busy,
    offLabel: 'Idle',
    defaultOn: false,
    runsFor,
});
/**
 * What each prop does when used. Kinds missing from this table are scenery:
 * clicking them still selects them, but there is nothing to work.
 */
export const FURNITURE_INTERACTIONS = {
    /* things that swing */
    door: swings({ solidWhenOn: false, solidWhenOff: true }),
    elevator: swings({ turnOn: 'Open doors', turnOff: 'Close doors', defaultOn: false }),
    phone_booth: swings({ defaultOn: false }),
    window: swings({ defaultOn: false }),
    /* things with a lid */
    fridge: opens(),
    cabinet: opens({ turnOn: 'Open drawer', turnOff: 'Close drawer' }),
    lockers: opens(),
    microwave: opens(),
    umbrella: opens({ turnOff: 'Fold', onLabel: 'Open', offLabel: 'Folded', defaultOn: true }),
    /* things with a switch */
    lamp: powers(),
    floor_lamp: powers(),
    street_lamp: powers(),
    chandelier: powers(),
    neon_sign: powers(),
    ring_light: powers(),
    exit_sign: powers(),
    tv: powers(),
    screen: powers(),
    monitor: powers(),
    hologram: powers(),
    aquarium: powers({ turnOn: 'Light the tank', turnOff: 'Dim the tank' }),
    terrarium: powers({ turnOn: 'Light the tank', turnOff: 'Dim the tank' }),
    fire_pit: powers({
        turnOn: 'Light it',
        turnOff: 'Put it out',
        onLabel: 'Lit',
        offLabel: 'Out',
    }),
    bbq: powers({ turnOn: 'Light it', turnOff: 'Put it out', onLabel: 'Lit', offLabel: 'Out' }),
    pizza_oven: powers({
        turnOn: 'Light it',
        turnOff: 'Put it out',
        onLabel: 'Lit',
        offLabel: 'Out',
    }),
    fountain: powers({ turnOn: 'Start', turnOff: 'Stop', onLabel: 'Running', offLabel: 'Still' }),
    waterfall_wall: powers({
        turnOn: 'Start',
        turnOff: 'Stop',
        onLabel: 'Running',
        offLabel: 'Still',
    }),
    arcade: powers(),
    claw_machine: powers(),
    jukebox: powers({ turnOn: 'Play', turnOff: 'Stop', onLabel: 'Playing', offLabel: 'Quiet' }),
    karaoke: powers({ turnOn: 'Play', turnOff: 'Stop', onLabel: 'Playing', offLabel: 'Quiet' }),
    treadmill: powers({
        turnOn: 'Start',
        turnOff: 'Stop',
        onLabel: 'Running',
        offLabel: 'Idle',
        defaultOn: false,
    }),
    sauna: powers({ turnOn: 'Heat it', turnOff: 'Switch off', onLabel: 'Hot', offLabel: 'Cold' }),
    vr_station: powers({ defaultOn: false }),
    camera_rig: powers({ turnOn: 'Roll', turnOff: 'Cut', onLabel: 'Rolling', offLabel: 'Off' }),
    mixing_desk: powers({ defaultOn: false }),
    /* things you sit in */
    chair: seats(),
    bar_stool: seats(),
    armchair: seats(),
    couch: seats(),
    bench: seats(),
    swing_bench: seats(),
    beanbag: seats({ turnOn: 'Flop down' }),
    hammock: seats({ turnOn: 'Lie down', turnOff: 'Get up' }),
    nap_pod: seats({ turnOn: 'Lie down', turnOff: 'Get up' }),
    massage_chair: seats(),
    meditation: seats({ turnOn: 'Sit', turnOff: 'Rise' }),
    yoga_mat: seats({ turnOn: 'Roll it out', turnOff: 'Roll it up', onLabel: 'In use' }),
    /* things that do something and stop */
    coffee: runs('Brew a coffee', 4500, 'Brewing'),
    vending_machine: runs('Buy a snack', 2500, 'Dispensing'),
    water_cooler: runs('Pour a cup', 2200, 'Pouring'),
    sink: runs('Run the tap', 2500, 'Running'),
    printer: runs('Print', 3500, 'Printing'),
    printer_3d: runs('Print', 5000, 'Printing'),
    gong: runs('Ring it', 1800, 'Ringing'),
    piano: runs('Play', 4000, 'Playing'),
    photo_booth: runs('Take a photo', 3000, 'Shooting'),
    darts: runs('Throw', 1600, 'In play'),
    basketball: runs('Shoot', 1600, 'In play'),
    punching_bag: runs('Hit it', 1800, 'In use'),
    cake: runs('Cut a slice', 2000, 'Cutting'),
    balloons: runs('Bat one', 1600, 'Bobbing'),
    fireworks: runs('Set it off', 3200, 'Firing'),
    confetti: runs('Pop it', 2400, 'Popping'),
    first_aid: runs('Take a plaster', 1800, 'Open'),
    charging_dock: runs('Charge a phone', 3000, 'Charging'),
    robot: runs('Say hello', 2000, 'Chirping'),
    weights: runs('Lift', 2200, 'In use'),
    snack_bar: runs('Grab a snack', 2000, 'In use'),
    bar: runs('Pour a drink', 2500, 'Pouring'),
};
export function furnitureInteraction(kind) {
    return FURNITURE_INTERACTIONS[kind];
}
export function isInteractive(kind) {
    return kind in FURNITURE_INTERACTIONS;
}
/**
 * The props that can carry a widget on their face.
 *
 * Every one of them is already a `switch` prop with a glass front, which is
 * what makes the binding work at all: a screen that has been switched off is
 * a dark rectangle, and the office should read as an office rather than as a
 * dashboard that happens to have chairs in it. The whiteboard is deliberately
 * not on the list — it is drawn as a matte surface people scribble on, and
 * there is a real whiteboard feature that owns that prop already.
 */
export const SCREEN_PROP_KINDS = ['screen', 'tv', 'monitor', 'hologram'];
export function isScreenProp(kind) {
    return SCREEN_PROP_KINDS.includes(kind);
}
/** The state a prop sits in before anyone has touched it. */
export function restingFurnitureState(kind) {
    const interaction = furnitureInteraction(kind);
    if (!interaction)
        return undefined;
    return { on: interaction.defaultOn, at: new Date(0).toISOString() };
}
/**
 * Whether a prop is currently open, lit, running or occupied.
 *
 * Momentary props are timed rather than latched: the stored state carries the
 * moment it finishes, so a client that missed the reset broadcast — or that
 * joined halfway through — still sees the coffee machine stop brewing.
 */
export function isFurnitureOn(kind, state, now = Date.now()) {
    const interaction = furnitureInteraction(kind);
    if (!interaction)
        return false;
    if (!state)
        return interaction.defaultOn;
    if (interaction.kind === 'momentary') {
        return state.until !== undefined && Date.parse(state.until) > now;
    }
    if (interaction.kind === 'seat')
        return state.by !== undefined;
    return state.on;
}
/** How far through its run a momentary prop is, 0..1. Zero when at rest. */
export function furnitureUseProgress(kind, state, now = Date.now()) {
    const interaction = furnitureInteraction(kind);
    if (!interaction || interaction.kind !== 'momentary' || !state?.until)
        return 0;
    const ends = Date.parse(state.until);
    const runsFor = interaction.runsFor ?? 2000;
    const elapsed = runsFor - (ends - now);
    if (elapsed < 0 || elapsed > runsFor)
        return 0;
    return elapsed / runsFor;
}
/** Blocks movement right now? A closed door does; the same door open does not. */
export function isFurnitureSolid(item, state, now = Date.now()) {
    const interaction = furnitureInteraction(item.kind);
    if (!interaction)
        return item.solid;
    const on = isFurnitureOn(item.kind, state, now);
    return (on ? interaction.solidWhenOn : interaction.solidWhenOff) ?? item.solid;
}
/** How much of a voice this kind of prop stops, 0..1. Scenery stops none. */
export function furnitureOcclusion(kind) {
    return FURNITURE_BY_KIND[kind]?.occludes ?? 0;
}
/** Whether a prop is currently something sound has to get through. */
export function isFurnitureOccluding(item, state, now = Date.now()) {
    return furnitureOcclusion(item.kind) > 0 && isFurnitureSolid(item, state, now);
}
/**
 * The walls of a floor plan, as the audio model sees them.
 *
 * Built from the same furniture and the same live state the movement code
 * uses, so a door that is shut to walk through is also shut to talk through,
 * and one that somebody opened lets both a person and a voice back in.
 */
export function occludersOf(furniture, states, now = Date.now()) {
    const read = (id) => states instanceof Map ? states.get(id) : states?.[id];
    const occluders = [];
    for (const item of furniture) {
        if (!isFurnitureOccluding(item, read(item.id), now))
            continue;
        occluders.push({
            rect: { x: item.pos.x, y: item.pos.y, w: item.w, h: item.h },
            blocks: furnitureOcclusion(item.kind),
        });
    }
    return occluders;
}
/** "Open" / "Closed" / "Taken" — the prop's state in a word, for the UI. */
export function furnitureStateLabel(kind, state, now = Date.now()) {
    const interaction = furnitureInteraction(kind);
    if (!interaction)
        return undefined;
    return isFurnitureOn(kind, state, now) ? interaction.onLabel : interaction.offLabel;
}
/** The verb for what using it would do next — "Close", "Turn on", "Sit down". */
export function furnitureActionLabel(kind, state, now = Date.now()) {
    const interaction = furnitureInteraction(kind);
    if (!interaction)
        return undefined;
    return isFurnitureOn(kind, state, now) ? interaction.turnOff : interaction.turnOn;
}
/**
 * The next state of a prop after `userId` uses it.
 *
 * Pure, and the single place the rules live: the server calls it to decide
 * what to broadcast, and the tests call it to pin the rules down. Anything
 * that depends on the rest of the room — who is standing in the doorway, how
 * far away the user is — is checked by the caller, which is the only side that
 * knows.
 */
export function useFurniture(item, current, userId, now = Date.now()) {
    const interaction = furnitureInteraction(item.kind);
    if (!interaction)
        return { ok: false, error: 'There is nothing to use here' };
    const at = new Date(now).toISOString();
    if (interaction.kind === 'seat') {
        const occupant = current?.by;
        if (occupant && occupant !== userId) {
            return { ok: false, error: 'Someone is already sitting there' };
        }
        return occupant
            ? { ok: true, state: { on: false, at } }
            : { ok: true, state: { on: true, by: userId, at } };
    }
    if (interaction.kind === 'momentary') {
        return {
            ok: true,
            state: {
                on: true,
                by: userId,
                until: new Date(now + (interaction.runsFor ?? 2000)).toISOString(),
                at,
            },
        };
    }
    return { ok: true, state: { on: !isFurnitureOn(item.kind, current, now), at } };
}
/* ------------------------------ bookable -------------------------------- */
/**
 * The props that are a place to work rather than a thing in the room.
 *
 * A desk is the obvious one; a drafting table and a mixing desk are somebody's
 * station for the afternoon in exactly the same sense. Listed rather than
 * derived because the catalogue's categories answer a different question —
 * "desks" also holds printers and cabinets, which nobody books.
 */
export const BOOKABLE_DESK_KINDS = [
    'desk',
    'standing_desk',
    'double_desk',
    'drafting_table',
    'mixing_desk',
];
/**
 * Whether one prop can be booked for a while.
 *
 * Anything you can sit in counts as well as the desks: a phone booth, a
 * beanbag in the quiet corner, a stool at the bar. If a floor's "desks" are
 * really a row of armchairs, they are still the thing people run out of.
 */
export function isBookableDesk(kind) {
    if (BOOKABLE_DESK_KINDS.includes(kind))
        return true;
    return furnitureInteraction(kind)?.kind === 'seat';
}
/* --------------------------- reaching for it --------------------------- */
/** Distance from a point to the nearest edge of a prop's footprint. */
export function distanceToFurniture(pos, item) {
    const dx = Math.max(item.pos.x - pos.x, 0, pos.x - (item.pos.x + item.w));
    const dy = Math.max(item.pos.y - pos.y, 0, pos.y - (item.pos.y + item.h));
    return Math.hypot(dx, dy);
}
/** You have to be next to something to work it, exactly as in a real office. */
export function canReachFurniture(pos, item) {
    return distanceToFurniture(pos, item) <= REACH_RADIUS;
}
/**
 * The interactive prop an avatar at `pos` would use — the nearest one within
 * arm's reach. Drives both the "E · Open" prompt on the canvas and what the
 * key actually works, so the two can never disagree.
 */
export function reachableFurniture(pos, furniture) {
    let best;
    let bestDistance = REACH_RADIUS;
    for (const item of furniture) {
        if (!isInteractive(item.kind))
            continue;
        const d = distanceToFurniture(pos, item);
        if (d > bestDistance)
            continue;
        best = item;
        bestDistance = d;
    }
    return best;
}
